import GetWebhooks from '@/graphql/Webhooks/GetWebhooks.gql'
import GetEvents from '@/graphql/Webhooks/GetEvents.gql'
import TestWebhook from '@/graphql/Webhooks/TestWebhook.gql'
import updateWebhookStatus from '@/graphql/Webhooks/UpdateStatusWebhook.gql'
import AddWebhook from '@/graphql/Webhooks/AddWebhook.gql'
import DeleteWebhook from '@/graphql/Webhooks/DeleteWebhook.gql'

import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getWebhooks ({ commit, dispatch }, { pageNumber, perPage }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetWebhooks,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber: pageNumber,
          perPage: 10
        }
      })
      return data.getWebhooks
    } catch (error) {
      dispatch('showError', error)
    }
  },
  async getFinancialEvents ({ commit, dispatch }, { pagination, paginator = true }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetEvents,
        fetchPolicy: 'no-cache',
        variables: {
          pagination
        }
      })
      return data.getFinancialEvents
    } catch (error) {
      dispatch('showError', error)
    }
  },
  async testWebhook ({ commit, dispatch }, { webhookId, eventId }) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: TestWebhook,
        variables: {
          webhookId: webhookId,
          eventId: eventId
        }
      })
      return data.testWebhook
    } catch (error) {
      dispatch('showError', error)
    }
  },
  async updateWebhookStatus ({ commit, dispatch }, { webhookId }) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: updateWebhookStatus,
        variables: {
          webhookId: webhookId
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El webhook se actualizado correctamente' })
      return data.updateWebhookStatus
    } catch (error) {
      dispatch('showError', error)
    }
  },
  async addWebhook ({ commit, dispatch }, { url, event, description, headers }) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: AddWebhook,
        variables: {
          url: url,
          event: event,
          description: description,
          headers: headers
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El webhook se ha creado correctamente' })
      return data.saveFinancialWebhook
    } catch (error) {
      dispatch('showError', error)
    }
  },
  async deleteWebhook ({ commit, dispatch }, { webhookId }) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: DeleteWebhook,
        variables: {
          webhookId: webhookId
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El webhook se elimino correctamente' })
      return data.deleteWebhook
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
